<template>
  <div class="container is-fluid has-text-centered">
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
    <br/>
    <div id="url_expired" style="text-align: center; width: 90%;">
      <h4>Welcome to Doodhvale, Please wait...</h4>
    </div>
    <div id="url_valid">
      <!-- bill-header-start -->
      <div class="row">
        <div class="col-sm-1"></div>
        <div class="col-sm-10">
          <div class="col-sm-5" style="float:left;text-align:justify">
            <p class="bill-header-content"><b> Bill No. : </b> {{apiDataObj.bill_no}}</p>
            <p class="bill-header-content"><b> Bill Cycle : </b> {{apiDataObj.bill_cycle}}  ({{convertDate(apiDataObj.start_date)}} - {{convertDate(apiDataObj.end_date)}})</p>
            <p class="bill-header-content"><b> Dated : </b> {{convertDate(apiDataObj.billing_gen_date)}} </p>
            <p class="bill-header-content"><b> Gst No : </b> {{apiDataObj.gst_no}} </p>
          </div>
          <!-- <div id="logo-lockup" class="col-sm-offset-1" style="text-align:center;height:20%;width:20%;float:left"> <img src= "/admin-lte/dist/img/doodhvale.png" style="height:130px;width:100%; margin-bottom:10px;" alt="Logo" />
          </div> -->
          <div class="col-sm-5" style="float:right; text-align:justify">
            <p class="bill-header-content"><b> Customer Name: </b>{{apiDataObj.customer_name}}</p>
            <p class="bill-header-content"><b> Customer Mobile: </b>{{apiDataObj.customer_mobile}}</p>
            <p class="bill-header-content"><b> Address: </b>{{apiDataObj.customer_address}}</p>
          </div>
        </div>
        <div class="col-sm-1"></div>
      </div>
      <!-- bill-header-end -->
      <!-- bill-breakup-start -->
      <div class="row">
        <div class="col-sm-1"></div>
        <div class="col-sm-10">
          <table class="table table-bordered table-condensed table-hover small kv-table">
            <tbody>
              <tr class="success">
                <th colspan="10" class="text-center text-danger">Bill Amount Breakup</th>
              </tr>
              <tr class="active">
                <th class="text-center">#</th>
                <th>Date</th>
                <th>Product Name</th>
                <th>Status</th>
                <th class="text-right">Unit Price(Rs)</th>
                <th class="text-right">Del Qty.</th>
                <th class="text-right">Amt.(Rs)</th>
              </tr>
              <template v-if="Array.isArray(apiDataObj.billing_detail) && apiDataObj.billing_detail.length">
                  <template v-for="(billing_detail, index) in apiDataObj.billing_detail">
                    <tr v-bind:key="billing_detail.bill_no">
                      <td class="text-center">{{index+1}}</td>
                      <td>{{convertDate(billing_detail.delivery_date)}}</td>
                      <td>{{billing_detail.product}}</td>
                      <td>{{billing_detail.status}}</td>
                      <td class="text-right">{{(billing_detail.mrp).toFixed(2)}}</td>
                      <td class="text-right">{{billing_detail.delivered}}</td>
                      <td class="text-right">{{(billing_detail.row_amount).toFixed(2)}}</td>
                    </tr>
                  </template>
              </template>
              <template v-else>
                <tr>
                  <td class="text-center">1</td>
                  <td></td>
                  <td></td>
                  <td> No Delivery breakup found</td>
                  <td class="text-right"></td>
                </tr>
              </template>
                <tr class="">
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th class="text-right">Total</th>
                  <th class="text-right">{{apiDataObj.delivered_quantity}}</th>
                  <th class="text-right">{{apiDataObj.sub_total}}</th>
                </tr>
                <template v-if="apiDataObj.referral_discount != 0">
                  <tr class="">
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th class="text-right">Referral Discount</th>
                    <th></th>
                    <th class="text-right">-{{apiDataObj.referral_discount}}</th>
                  </tr>
                </template>
                <template v-if="apiDataObj.voucher_discount != 0">
                  <tr class="">
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th class="text-right">Voucher Discount</th>
                      <th></th>
                      <th class="text-right">-{{apiDataObj.voucher_discount}}</th>
                  </tr>
                </template>
                <template v-if="apiDataObj.tax != 0">
                  <tr class="">
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th class="text-right">Taxes</th>
                      <th></th>
                      <th class="text-right">+{{apiDataObj.tax}}</th>
                  </tr>
                </template>
                <template v-if="apiDataObj.previous_due_amount != 0">
                  <tr class="">
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th class="text-right">Previous Due Amount</th>
                    <th></th>
                    <th class="text-right">{{apiDataObj.previous_due_amount}}</th>
                  </tr>
                </template>
                <template v-if="apiDataObj.broken_bottle != 0">
                  <tr class="">
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th class="text-right">Broken Bottle Amount</th>
                    <th class="text-center"></th><th class="text-right">+{{(apiDataObj.broken_bottle * apiDataObj.broken_bottle_charge).toFixed(2)}}</th>
                  </tr>
                </template>
                  <tr class="active">
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th class="text-right">Total Bill Amount</th>
                    <th></th>
                    <th class="text-right">{{apiDataObj.net_payable_amount}}</th>
                  </tr>
                <template v-if="apiDataObj.empty_bottle != 0">
                  <tr class="">
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th class="text-right">Your Pending Empty Bottle</th>
                    <th class="text-right">{{apiDataObj.empty_bottle}}</th>
                    <th></th>
                  </tr>
                </template>
            </tbody>
          </table>
        </div>
        <div class="col-sm-1"></div>
      </div>
      <!-- bill-breakup-end -->
      <!-- broken-bottle-start -->
      <div class="row" v-if="apiDataObj.broken_bottle > 0">
        <div class="col-sm-1"></div>
        <div class="col-sm-10">
          <table class="table table-bordered table-condensed table-hover small kv-table">
            <tbody>
              <tr class="success">
                <th colspan="5" class="text-center text-danger">Broken Bottle Details</th>
              </tr>
              <tr class="active">
                <th class="text-center">#</th> 
                <th>Date</th>
                <th class="text-right">Unit Price(Rs)</th>
                <th class="text-right">Qty.</th>
                <th class="text-right">Amt.(Rs)</th>
              </tr>
              <template v-for="(billing_detail, index) in apiDataObj.billing_detail">
                <template v-if="billing_detail.broken_bottle > 0">
                  <tr v-bind:key="billing_detail.bill_no">
                    <td class="text-center">{{index+1}}</td>
                    <td>{{convertDate(billing_detail.delivery_date)}}</td>
                    <td class="text-right">{{apiDataObj.broken_bottle_charge}}</td>
                    <td class="text-right">{{billing_detail.broken_bottle}}</td>
                    <td class="text-right">{{(billing_detail.broken_bottle * apiDataObj.broken_bottle_charge).toFixed(2)}}</td>
                  </tr>
                </template>
              </template>
              <tr class="">
                <th></th><th></th><th class="text-right">Total</th><th class="text-right">{{apiDataObj.broken_bottle}}</th><th class="text-right">{{(apiDataObj.broken_bottle * apiDataObj.broken_bottle_charge).toFixed(2)}}</th>
              </tr>
              <tr class="active">
                <th></th><th></th><th class="text-right">Total Broken Bottle Amount(Rs)</th><th></th><th class="text-right">{{(apiDataObj.broken_bottle * apiDataObj.broken_bottle_charge).toFixed(2)}}</th>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-sm-1"></div>
      </div>
      <!-- broken-bottle-end -->                
      <!-- gst-start -->
      <div class="row" v-if="(apiDataObj.igst_amount != 0 || apiDataObj.cgst_amount != 0 || apiDataObj.sgst_amount != 0)">
        <div class="col-sm-1"></div>
          <div class="col-sm-10">
            <table class="table table-bordered table-condensed table-hover small kv-table">
              <tbody>
                <tr class="success">
                  <th colspan="4" class="text-center text-danger">Gst Charges</th>
                </tr>
                <tr class="active">
                  <th class="text-center">IGST</th>
                  <th class="text-center">CGST</th>
                  <th class="text-center">SGST</th>
                </tr>
                <tr>
                  <td class="text-center">{{apiDataObj.igst_amount}}</td><td class="text-center">{{apiDataObj.cgst_amount}}</td><td class="text-center">{{apiDataObj.sgst_amount}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        <div class="col-sm-1"></div>
      </div>
      <!-- gst-end -->
    </div>
  </div>
</template>
<script>
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  import LTable from 'src/components/UIComponents/Table.vue'
  import Checkbox from 'src/components/UIComponents/Inputs/Checkbox.vue'
  import axios from 'axios'
  export default {
    components: {
      Checkbox,
      Card,
      LTable,
      ChartCard,
      StatsCard
    },
    data () {
      return {
        apiDataObj: {},
        urlInterface: {},
        isLoading: true,
        isFullPage: true,
        count: 0
      }
    },
    created () {
      this.fetchData()
    },
    methods: {
      fetchData () {
        const params = new URLSearchParams()
        var fullUrl = document.URL
        var splitUrl = fullUrl.split('bill?')
        params.append('url_str', splitUrl[1])
        axios({
          url: process.env.BASE_API + '/accounts/fetch-url-interface-data',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        }).then(response => {
          this.urlInterface = {}
          if (response.data.status === '000001' || response.data.status === '000002' || response.data.status === '000003') {
            this.urlInterface.error_msg = response.data.msg
            document.getElementById('url_valid').style.display = 'none'
            this.isLoading = false
          } else {
            document.getElementById('url_expired').style.display = 'none'
            this.urlInterface.action_name = response.data.action_name
            this.urlInterface.url_interface_id = response.data.url_interface_id
            this.invokeUrlAction()
            this.isLoading = false
          }
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            alert(this.list)
          }
          setTimeout(() => {
            this.isLoading = false
          }, 10000)
        })
        .catch(e => {
          this.isLoading = false
          alert('not ok')
        })
      },
      invokeUrlAction () {
        const params = new URLSearchParams()
        params.append('url_interface_id', this.urlInterface.url_interface_id)
        params.append('action_name', this.urlInterface.action_name)
        axios({
          url: process.env.BASE_API + '/accounts/invoke-url-action',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          if (response.data.action_response.user_id === null || response.data.action_response.user_id === 0 || response.data.action_response.user_id === '0' || response.data.action_response.user_id === 'undefined') {
            window.location.reload()
          }
          switch (this.urlInterface.action_name) {
            case 'customer_bill':
              this.apiDataObj = response.data.action_response.bill_list
              this.apiDataObj.sub_total = (this.apiDataObj.sub_total).toFixed(2)
              this.apiDataObj.igst_amount = (this.apiDataObj.igst_amount).toFixed(2)
              this.apiDataObj.cgst_amount = (this.apiDataObj.cgst_amount).toFixed(2)
              this.apiDataObj.sgst_amount = (this.apiDataObj.sgst_amount).toFixed(2)
              this.apiDataObj.referral_discount = (this.apiDataObj.referral_discount).toFixed(2)
              this.apiDataObj.voucher_discount = (this.apiDataObj.voucher_discount).toFixed(2)
              this.apiDataObj.tax = (this.apiDataObj.tax).toFixed(2)
              this.apiDataObj.bill_amount = (this.apiDataObj.bill_amount).toFixed(2)
              this.apiDataObj.previous_due_amount = (this.apiDataObj.previous_due_amount).toFixed(2)
              this.apiDataObj.net_payable_amount = (this.apiDataObj.net_payable_amount).toFixed(2)
              this.apiDataObj.broken_bottle_charge = (this.apiDataObj.broken_bottle_charge).toFixed(2)
              break
            default:
              break
          }
          setTimeout(() => {
            this.isLoading = false
          }, 10000)
        }).catch(e => {
          alert('not ok')
        })
      },
      convertDate (dateString) {
        var mydate = new Date(dateString).toDateString().split(' ')
        return mydate[2] + '-' + mydate[1] + '-' + mydate[3]
      }
    }
}
</script>
<style>
.success{background-color : #d0e9c6 !important}
.active {
  background-color: #f5f5f5 !important;
}

.table>tbody>tr>td{
  font-family:Calibari !important;
  text-align: left;
}

.table>tbody>tr>th{
  font-family:Calibari !important;
  text-align: left;
}
.table-bordered th, .table-bordered td {
  padding: 5px !important;
}
.bill-header-content {
  font-size: 11px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Bill.vue